import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/root-canal/hero";
import WhatAndWhy from "../components/root-canal/what-and-why";
import Process from "../components/root-canal/process";
import AfterCare from "../components/root-canal/aftercare";
import CTA from "../components/root-canal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import QuestionRC from "../components/root-canal/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Root Canal Dentist in Ilkley, West Yorkshire | Regent Dental",
    serviceType: "Root Canal",
    url: "https://www.regent-dental.co.uk/root-canal",
    description:
      "Root canal treatments at Regent Dental are performed to treat infection in the tooth’s root, saving the natural tooth and preventing further damage.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is root canal treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Root canal treatment is a procedure that removes infection from the inside of a tooth, saving it from extraction and restoring it to full health.",
        },
      },
      {
        "@type": "Question",
        name: "Why might I need a root canal?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "You may need a root canal if the pulp inside your tooth becomes infected or damaged, often due to deep decay, a crack, or trauma. Without treatment, the infection could spread and cause more serious problems.",
        },
      },
      {
        "@type": "Question",
        name: "Does root canal treatment hurt?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Not at all! Thanks to modern techniques and gentle care, having a root canal feels much like having a standard filling. We’ll make sure you are comfortable and well looked after throughout.",
        },
      },
      {
        "@type": "Question",
        name: "What are the signs I might need a root canal?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Common signs include toothache, sensitivity to hot and cold, swelling, tenderness, or darkening of the tooth. However, sometimes there are no symptoms, which is why regular check-ups are so important.",
        },
      },
      {
        "@type": "Question",
        name: "How long does root canal treatment take?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "It usually takes one or two appointments, depending on the complexity of the tooth. We'll let you know exactly what to expect during your consultation.",
        },
      },
      {
        "@type": "Question",
        name: "What happens during the procedure?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We gently remove the infected or damaged tissue, carefully clean and disinfect the inside of the tooth, and then seal it to prevent further infection. Often, a crown is placed afterwards to strengthen the tooth.",
        },
      },
      {
        "@type": "Question",
        name: "Will I need a crown after my root canal?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "In many cases, especially for back teeth, a crown is recommended to protect and strengthen the tooth after treatment.",
        },
      },
      {
        "@type": "Question",
        name: "How successful is root canal treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Root canal treatment is highly successful and can keep your tooth healthy for many years. We use the latest techniques and materials to give you the best possible outcome.",
        },
      },
      {
        "@type": "Question",
        name: "What should I expect after the treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "It’s normal to feel a little tender for a few days, but this usually settles quickly. We’ll give you all the advice you need to ensure a smooth recovery.",
        },
      },
      {
        "@type": "Question",
        name: "How do I book a consultation for root canal treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "If you’re experiencing any dental pain or concerns, simply get in touch with us. Our caring team at Regent Dental is here to help you feel better and protect your smile.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>
          Root Canal Dentist in Ilkley, West Yorkshire | Regent Dental
        </title>
        <meta
          name="description"
          content="Root canal treatments at Regent Dental can relieve tooth pain. Our skilled dentists ensure comfortable and effective procedures for lasting oral health.​"
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/root-canal"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <AfterCare />
      <QuestionRC />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
